import React from "react";
import { useIntl } from "react-intl";
import SeoHead from "~/components/seo/SeoHead";

export default function CollectionsPageSeo() {
  const intl = useIntl();

  return (
    <SeoHead
      title={intl.formatMessage({ defaultMessage: 'Local Government Innovation Collections – Govlaunch', id: '1DDlhf' })}
      description={intl.formatMessage({
        defaultMessage: 'Search Govlaunch Collections for local government innovation projects and technology across all departments.', id: 'uLXEMC',
      })}
    />
  );
}
